import { IBookingTimeFrame } from '../config/bookings';
import { AllBookingTimeFrame, IAllowedBookingTimeFrames } from '../entities/gym/booking-time-frames';

function isTimeFrameAllowed(
  overridden: AllBookingTimeFrame[] | undefined,
  onDemand: boolean,
  timeFrame: IBookingTimeFrame,
) {
  if (!overridden) {
    if (onDemand) {
      return timeFrame.allowOnDemandByDefault ?? true;
    }
    return timeFrame.allowBookingsByDefault ?? true;
  }
  return overridden.some((o) => timeFrame.timeFrame === o);
}

export class AllowedBookingTimeFrames {
  constructor(private overridden?: IAllowedBookingTimeFrames) {
  }

  public isAllowedForCircuitBookings(timeFrame: IBookingTimeFrame): boolean {
    const onDemand = false;
    return isTimeFrameAllowed(this.overridden?.circuit?.bookings, onDemand, timeFrame);
  }

  public isAllowedForCircuitOnDemand(timeFrame: IBookingTimeFrame): boolean {
    const onDemand = true;
    return isTimeFrameAllowed(this.overridden?.circuit?.onDemand, onDemand, timeFrame);
  }

  public isAllowedForStaticFunctionalBookings(timeFrame: IBookingTimeFrame): boolean {
    const onDemand = false;
    return isTimeFrameAllowed(this.overridden?.staticFunctional?.bookings, onDemand, timeFrame);
  }

  public isAllowedForStaticFunctionalOnDemand(timeFrame: IBookingTimeFrame): boolean {
    const onDemand = true;
    return isTimeFrameAllowed(this.overridden?.staticFunctional?.onDemand, onDemand, timeFrame);
  }

  public isAllowedForStaticMachineBookings(timeFrame: IBookingTimeFrame): boolean {
    const onDemand = false;
    return isTimeFrameAllowed(this.overridden?.staticMachine, onDemand, timeFrame);
  }
}
